import SearchBar from "@/components/library/Filters/SearchBar";
import GradientScroll from "@/components/library/Misc/GradientScroll";
import useDebounce from "@/hooks/useDebounce";
import ModalContainer from "@dinesapp/dines-ui/components/Modals/ModalContainer";
import { useState } from "react";
import Radio from "@dinesapp/dines-ui/components/Inputs/Radio";
import { RadioLabelPosition } from "@dinesapp/dines-ui/components/Inputs/Types/Radio";

const VenueModal = ({
  onToggleModal,
  venues,
  selectedVenue,
  setSelectedVenue,
}) => {
  const [venueInputSearch, setVenueInputSearch] = useState<string>("");
  const debouncedVenueInputSearch = useDebounce(venueInputSearch, 300);

  const filterOptions = (query: string) => {
    const updatedVenues = venues.map((venue) => ({
      id: venue.id,
      isChecked: venue.id === selectedVenue?.id,
      label: venue.name,
      onChange: () => {
        onToggleModal();
        setSelectedVenue(venue.id);
      },
    }));

    if (query === "") return updatedVenues;

    const lowerCaseQuery = query.toLowerCase();
    return updatedVenues.filter((venue) =>
      venue.label.toLowerCase().includes(lowerCaseQuery),
    );
  };

  return (
    <ModalContainer
      container={{
        id: "account-modal",
        onClose: () => onToggleModal(),
        zIndex: "z-50",
        width: "w-full",
        height: "h-[90vh]",
        onlyCloseOnButtonClick: true,
      }}
      header={{
        id: "account-modal-header",
        title: "Select an Account",
        showBorder: true,
      }}
    >
      <div className="flex h-full flex-col p-5 pt-2">
        <div className="flex w-full items-center space-x-2">
          <SearchBar
            vm={{
              labels: {
                id: "account-modal-search-bar",
                placeholder: "Search accounts",
                backgroundColour: "bg-gray-100",
                containerClassName: "w-full  m-0",
                width: "w-full shadow-none",
              },
              value: venueInputSearch,
              debouncedValue: debouncedVenueInputSearch,
              onClearSearch: () => {
                setVenueInputSearch("");
              },
              onHandleSearch: (event) => {
                setVenueInputSearch(event.target.value);
              },
            }}
          />
        </div>

        <div className=" h-full">
          <GradientScroll noScrollbar={true}>
            <div className="mt-4 flex flex-col space-y-4">
              {filterOptions(debouncedVenueInputSearch).map((item) => (
                <div key={item.id} className="flex justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="self-start">
                      <Radio
                        id={item.id}
                        name="venue"
                        label={item.label}
                        isChecked={item.isChecked}
                        onChange={item.onChange}
                        labelPosition={RadioLabelPosition.Trailing}
                        labelClassName="text-dines-purple-darkest"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </GradientScroll>
        </div>
      </div>
    </ModalContainer>
  );
};

export default VenueModal;
